import React from 'react';

import {ContainerSummaryWithContainedItemIds} from 'samples/transfers/TransferModalUtil';
import * as TransferUtil from 'samples/transfers/TransferUtil';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

function InputContainerContentsError({
  inputContainer,
}: {
  inputContainer: ContainerSummaryWithContainedItemIds;
}): JSX.Element {
  return (
    <div className="u-small-spacing-top u-small-spacing-bottom">
      <InlineBanner
        bannerType={InlineBannerType.ERROR}
        dataTestAttrs={{component: 'InputContainerContentsError', element: 'root'}}
        text={TransferUtil.getTransferInputContentsErrorText(inputContainer)}
      />
    </div>
  );
}

export default function renderPossibleInputContainerContentsError({
  inputContainer,
}: {
  inputContainer: ContainerSummaryWithContainedItemIds;
}): JSX.Element | null {
  return !TransferUtil.isSourceContainerValidForTransfer(inputContainer) ? (
    <InputContainerContentsError inputContainer={inputContainer} />
  ) : null;
}
